import { render, staticRenderFns } from "./proof-view-event.vue?vue&type=template&id=89ef456c&scoped=true&"
import script from "./proof-view-event.vue?vue&type=script&lang=js&"
export * from "./proof-view-event.vue?vue&type=script&lang=js&"
import style0 from "./proof-view-event.vue?vue&type=style&index=0&id=89ef456c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89ef456c",
  null
  
)

export default component.exports